'use client';

import { FC } from 'react';
import ClerkUserAvatar from './ClerkUserAvatar';
import ClerkUserDetails from './ClerkUserDetails';

type Props = {
  showDetails?: boolean;
  showName?: boolean;
};

const ClerkUserGroup: FC<Props> = ({ showDetails = true, showName = true }) => {
  if (!showDetails) {
    return <ClerkUserAvatar />;
  }

  return (
    <div className="flex items-center gap-4 w-full min-w-0">
      <ClerkUserAvatar />
      <div className="min-w-0 flex-1">
        <ClerkUserDetails showName={showName} />
      </div>
    </div>
  );
};

export default ClerkUserGroup;
